import Home from "../pages/Home";
import Paths from "../utils/Paths";
import FAQ from "../pages/FAQ";
import SignUp from "../pages/Authentication/SignUp";
import SignIn from "../pages/Authentication/SignIn";
import GigDetail from "../pages/Gigs/GigDetail";
import ViewGigs from "../pages/Gigs/ViewGigs";
import SellerDashboard from "../pages/SellerDashboard/Dashboard";
import Profile from "../pages/Profile/Profile";
import GigCreation from "../pages/Gigs/GigCreation";
import Error404 from "../components/common/Error404";
import Settings from "../pages/Settings";
import ManageOrders from "../pages/Orders/ManageOrders";
import OrderDetail from "../pages/Orders/OrderDetail";
import Forgetpassword from "../pages/Authentication/ForgetPassword";
import MobileSso from "../pages/Authentication/MobileSso";
import IncomingOffers from "../pages/Offers/IncomingOffers";
import SentOffers from "../pages/Offers/SentOffers";
import ManageGigs from "../pages/Gigs/ManageGigs";
import Payment from "../pages/Payment";
import Earnings from "../pages/Earnings";
import UpdateGig from "../pages/Gigs/UpdateGig";
import BecomeSeller from "../pages/SellerDashboard/BecomeSeller";
import SellerOrderDetail from "../pages/Orders/SellerOrderDetails";
import Favourites from "../pages/Favourites";
import Inbox from "../pages/Inbox";
import LegalNDP from "../pages/Legal/LegalNDP";
import LegalTOS from "../pages/Legal/LegalTOS";
import LegalPP from "../pages/Legal/LegalPP";
import LegalPTOS from "../pages/Legal/LegalPTOS";
import DeleteAccount from "../pages/DeleteAccount";

//buyer
import PostProject from "../pages/projects/PostProject";
import UpdateProject from "../pages/projects/UpdateProject";
import ProjectDetail from "../pages/projects/ProjectDetail";
import ManageProjects from "../pages/ManageProjects";

//employer
import EmployerDashboard from "../pages/EmployerDashboard/Dashboard";
import BecomeEmployer from "../pages/EmployerDashboard/BecomeEmployer";
import PostJob from "../pages/Jobs/PostJob";
import UpdateJob from "../pages/Jobs/UpdateJob";
import JobDetail from "../pages/Jobs/JobDetail";
import ManageJobs from "../pages/ManageJobs";
import IncomingCandidates from "../pages/IncomingCandidates";

//subscription
import SubscriptionPlans from "../pages/EmployerDashboard/SubscriptionPlans";
import SubscriptionCancel from "../pages/EmployerDashboard/SubscriptionCancel"
import SubscriptionSuccess from "../pages/EmployerDashboard/SubscriptionSuccess";
import SubscriptionPlansPublic from "../pages/Public/SubscriptionPlansPublic";

// SEO landing pages
import CategoryPage from "../pages/Services/CategoryPage";

export const PrivateRoutes = [
  { path: Paths.seller, component: <SellerDashboard /> },
  { path: Paths.settings, component: <Settings /> },
  { path: Paths.becomeSeller, component: <BecomeSeller /> },
  { path: Paths.becomeEmployer, component: <BecomeEmployer /> },

  { path: Paths.inbox, component: <Inbox /> },
  { path: Paths.favourites, component: <Favourites /> },
  { path: Paths.updateProject, component: <UpdateProject /> },
  { path: Paths.incomingOffers, component: <IncomingOffers /> },
  { path: Paths.buyerOrders, component: <ManageOrders ordersType="Sent" /> },
  { path: Paths.deleteAccount, component: <DeleteAccount /> },

  //employer
  { path: Paths.manageJobs, component: <ManageJobs /> },
  { path: Paths.updateJob, component: <UpdateJob /> },
  { path: Paths.postJob, component: <PostJob /> },

  //buyer
  { path: Paths.manageProjects, component: <ManageProjects /> },
  { path: Paths.updateProject, component: <UpdateProject /> },
  { path: Paths.postProject, component: <PostProject /> },
  { path: Paths.orderDetail, component: <OrderDetail /> },

  { path: Paths.sentOffers, component: <SentOffers /> },

  // subscription (accessible to any logged-in user)
  { path: Paths.subscriptionPlans, component: <SubscriptionPlans /> },
  { path: Paths.subscriptionSuccess, component: <SubscriptionSuccess /> },
  { path: Paths.subscriptionCancel, component: <SubscriptionCancel /> },
];

export const SellerRoutes = [
  { path: Paths.payments, component: <Payment /> },
  { path: Paths.earnings, component: <Earnings /> },

  { path: Paths.manageGigs, component: <ManageGigs /> },
  { path: Paths.gigCreation, component: <GigCreation /> },
  { path: Paths.updateGig, component: <UpdateGig /> },
  { path: Paths.sentOffers, component: <SentOffers /> },
  {
    path: Paths.sellerOrders,
    component: <ManageOrders ordersType="Received" />,
  },
  { path: Paths.sellerOrderDetail, component: <SellerOrderDetail /> },
];

export const PublicRoutes = [
  { path: Paths.signUp, component: <SignUp /> },
  { path: Paths.signIn, component: <SignIn /> },
  { path: Paths.forgetPassword, component: <Forgetpassword /> },
  { path: Paths.subscriptionPlans, component: <SubscriptionPlansPublic /> },
];

export const commonRoutes = [
  { path: Paths.home, component: <Home /> },
  { path: Paths.mobileSso, component: <MobileSso /> },
  { path: Paths.faq, component: <FAQ /> },
  { path: Paths.error, component: <Error404 /> },
  { path: Paths.profile, component: <Profile /> },
  { path: Paths.viewGigs, component: <ViewGigs /> },
  { path: Paths.gigDetail, component: <GigDetail /> },
  //employer
  { path: Paths.jobDetail, component: <JobDetail /> },
  //buyer
  { path: Paths.projectDetail, component: <ProjectDetail /> },
  { path: Paths.legalTOS, component: <LegalTOS /> },
  { path: Paths.legalPP, component: <LegalPP /> },
  { path: Paths.legalPTOS, component: <LegalPTOS /> },
  { path: Paths.legalNDP, component: <LegalNDP /> },

  // SEO landing pages
  { path: Paths.servicesCategory, component: <CategoryPage /> },
  { path: Paths.servicesSubcategory, component: <CategoryPage /> },
];

export const EmployerRoutes = [
  { path: Paths.employer, component: <EmployerDashboard /> },
  { path: Paths.settings, component: <Settings /> },

  { path: Paths.inbox, component: <Inbox /> },
  { path: Paths.favourites, component: <Favourites /> },
  { path: Paths.JobCreation, component: <PostJob /> },
  { path: Paths.manageJobs, component: <ManageJobs /> },
  { path: Paths.updateJob, component: <UpdateJob /> },
  { path: Paths.payments, component: <Payment /> },
  { path: Paths.earnings, component: <Earnings /> },
  { path: Paths.incomingCandidates, component: <IncomingCandidates /> },
  {
    path: Paths.sellerOrders,
    component: <ManageOrders ordersType="Received" />,
  },
  { path: Paths.sentOffers, component: <SentOffers /> },

  // subscription
  { path: Paths.subscriptionPlans, component: <SubscriptionPlans /> },
  { path: Paths.subscriptionSuccess, component: <SubscriptionSuccess /> },
  { path: Paths.subscriptionCancel, component: <SubscriptionCancel /> },
];